<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col">
        <h4 class="text-center py-3">
          {{category.name}} [Categoria]
          <span
            class="badge"
            :class="category.kind == 'producto' ? 'badge-info' : 'badge-primary'"
          >{{category.kind}}</span>
        </h4>
        <div class="container">
          <div class="form-group">
            <label>Nombre</label>
            <input type="text" class="form-control" v-model="categoryForms.name" />
          </div>
          <div class="form-group">
            <label>CRR</label>
            <input type="number" class="form-control" v-model="categoryForms.crr" />
          </div>
          <div class="form-group">
            <label>Tipo</label>
            <select class="form-control" v-model="categoryForms.kind">
              <option>producto</option>
              <option>servicio</option>
            </select>
          </div>
          <span class="btn btn-treid btn-block" @click="handleSend()">guardar cambios</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../../tools/Api2";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import { mapState } from "vuex";
export default {
  name: "Category",
  data() {
    return {
      categories: [],
      CategorySelect: "",
      specSelected: "",
      category: {
        name: "",
        kind: ""
      },
      categoryForms: {
        name: "",
        crr: 0,
        kind: ""
      }
    };
  },
  components: {
    NavbarMain,
    NavbarAdmin
  },
  computed: {
    ...mapState(["auth"])
  },
  methods: {
    getCategory() {
      Api("category").get(this.$route.params.id).then(res => {
        this.categoryForms = {
          name: res.category.name,
          crr: res.category.crr,
          kind: res.category.kind
        };
        this.category = res.category; 
      })
    },
    handleSend() {
      if(!(this.categoryForms.kind && this.categoryForms.name))
        return;
      
      Api("category").patch(this.category._id, this.categoryForms).then( () => {
        return this.$router.push("/admin/categories");
      })
    }
  },
  created: async function() {
    this.getCategory();
  }
};
</script>